import React from "react"
import styles from "./Input.module.css"
import Label from "./Label"
import RequiredNotice from "./RequiredNotice"
import { ERRORS } from "./constants"

const Input = ({ id, label, onChange, value, required, error, className }) => {
  return (
    <div className={`${styles.container} ${className}`} data-testid="input-component">
      <Label id={id} required={required} hasError={Boolean(error)}>
        {label}
      </Label>
      <input
        id={id}
        data-testid="input"
        required={required}
        value={value}
        className={`${styles.input} ${error ? styles.error : ""}`}
        onChange={(e) => onChange(e.target.value)}
      />
      <RequiredNotice required={required} hasError={error === ERRORS.required} />
    </div>
  )
}

Input.defaultProps = {
  value: "",
  onChange: () => {},
  error: "",
  className: "",
}

export default Input
